import { Typography } from 'seagull/components/Typography';
import pluralize from "../../../../../utils/pluralize";
import { jsx as _jsx } from "react/jsx-runtime";
const UnbilledTimeActivities = _ref => {
  let {
    serviceTimeActivitiesLength
  } = _ref;
  return /*#__PURE__*/_jsx(Typography, {
    "data-testid": "unbilled-time-activities",
    variant: "paragraph2",
    skin: "success",
    children: "".concat(pluralize('unbilled activity', serviceTimeActivitiesLength, true))
  });
};
export default UnbilledTimeActivities;